export var isString = function isString(input) {
  return typeof input === "string";
};
export var includes = function includes(haystack, needle) {
  return haystack.indexOf(needle) !== -1;
};